/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HoldUpgradeOperationEnum } from './holdUpgradeOperationEnum';
import { EntityTypeEnum } from './entityTypeEnum';


export interface HoldUpgradeSpec { 
    entity_type: EntityTypeEnum;
    operation: HoldUpgradeOperationEnum;
    /**
     * Deployment or Org Ids
     */
    ids: Array<string>;
}
export namespace HoldUpgradeSpec {
}


